/***
 * Created on 2023/7/7
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useReducer} from 'react';
import {Link, Outlet, useLocation, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Cookie from 'js-cookie';


function Navigator(props) {
    const { t } = useTranslation();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const [appId, setAppId] = React.useState(searchParams.get('app_id'));
    const [app, setApp] = React.useState(null);
    const is_mobile_app = Cookie.get('mobile_app') === 'true';
    const [collapsed, setCollapsed] = React.useState('off');
    const resetLink = {
        all: 'unset'
    }

    function reducer(state, action) {
        if (action.trigger === 'resize') {
            return {
                ...state,
                status: action.status,
                isMobile: action.isMobile,
                trigger: action.trigger
            }
        }
        else if (action.trigger === 'toggle') {
            return {
                ...state,
                itemGroup: action.itemGroup,
                trigger: action.trigger,
                status: action.status
            }
        }
        else if (action.trigger === 'selectSubMenu') {
            const status = state.isMobile ? 'close-temp' : 'open';
            return {
                ...state,
                status,
                subMenu: action.subMenu
            }
        }
        else {
            return state;
        }
    }

    function initReducer() {
        const isMobile = window.innerWidth <= 767;
        const status = isMobile ? 'close-temp' : 'open';
        const path = location.pathname.split('/').filter(item => item !== "");
        let itemGroup, subMenu, rest;
        if (path && path.length > 0) {
            if (path.length >= 2) {
                [itemGroup, subMenu, ...rest] = path;
            }
            else {
                itemGroup = path[0];
                subMenu = 'profile';
            }
        }
        return {itemGroup, subMenu, status, isMobile, trigger: null};
    }

    const [state, dispatch] = useReducer(reducer, {}, initReducer);

    // const toggleGroup= (group, e) => {
    //     e.stopPropagation();
    //     if (e.target.classList.value.includes('app-nav-submenu__item') || e.target.nodeName === 'A') return;
    //     let status;
    //     if (state.itemGroup === group) {
    //         if (state.isMobile) {
    //             status = ['close', 'close-temp'].includes(state.status) ? 'open' : 'close-temp';
    //         }
    //         else {
    //             status = state.status === 'open' ? 'close' : 'open';
    //         }
    //     }
    //     else {
    //         status = 'open';
    //     }
    //     dispatch({
    //         trigger: 'toggle',
    //         itemGroup: group,
    //         status
    //     });
    // }
    //
    // const checkItemGroup = (name) => {
    //     let group_statu = 'close';
    //     if (state.itemGroup === name) {
    //         if (state.status === 'open' && state.isMobile && state.trigger !== 'toggle') {
    //             group_statu = 'temp-close';
    //         }
    //         else if (state.status === 'close-temp' && !state.isMobile && state.trigger !== 'toggle') {
    //             group_statu = 'open';
    //         }
    //         else {
    //             group_statu = state.status;
    //         }
    //     }
    //     return group_statu;
    // }

    const handleResize = () => {
        const is_mobile = window.innerWidth <= 767;
        let status;
        if (state.isMobile !== is_mobile) {
            if (is_mobile && state.status === 'open') {
                status = 'close-temp';
            }
            else if (!is_mobile && state.status === 'close-temp') {
                status = 'open';
            }
            else {
                status = state.status;
            }
        }
        else {
            status = state.status;
        }
        dispatch({
            trigger: 'resize',
            isMobile: is_mobile,
            status
        });
    }

    const getApp = async () => {
        let session_apps = sessionStorage.getItem('apps');
        let _app;
        if (session_apps) {
            session_apps = JSON.parse(session_apps);
            _app = session_apps?.[appId];
        }
        if (!_app || Object.keys(_app).length <= 0) {
            const resp = await fetch(`/ajax/app/${appId}`);
            const res = await resp.json();
            if (res && Object.keys(res).length > 0) {
                if (!session_apps) {
                    session_apps = {}
                }
                session_apps[appId] = res;
                sessionStorage.setItem('apps', JSON.stringify(session_apps));
            }
            setApp(res);
        }
        else {
            setApp(_app);
        }
    }

    const appRedirect = () => {
        window.location.href = `/app_redirect/${appId}`;
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (appId) {
            getApp();
        }

    }, [appId]);


    return (
        <>
        <nav className={`app-nav ${is_mobile_app || state.isMobile ? 'hide' : ''}`} data-nav-collapsed={collapsed}>
            {
                <>
                    <ul>
                        <Link to="/account/profile" style={resetLink}>
                            <li className={`app-nav-item ${state.subMenu === 'profile' ? 'active' : ""}`}
                                onClick={() => dispatch({trigger: 'selectSubMenu', subMenu: 'profile'})}>
                                <div className="app-nav-item-group">
                                    <div className="app-nav-item-group__icon" icon-type="profile"></div>
                                    <div className="app-nav-item-group__label">{t('@Profile@')}</div>
                                </div>
                            </li>
                        </Link>

                        <Link to="/account/security" style={resetLink}>
                            <li className={`app-nav-item ${state.subMenu === 'security' ? 'active' : ""}`}
                                onClick={() => dispatch({trigger: 'selectSubMenu', subMenu: 'security'})}>
                                <div className="app-nav-item-group">
                                    <div className="app-nav-item-group__icon" icon-type="security"></div>
                                    <div className="app-nav-item-group__label">{t('@Security@')}</div>
                                </div>
                            </li>
                        </Link>

                        <Link to="/account/activity" style={resetLink}>
                            <li className={`app-nav-item ${state.subMenu === 'activity' ? 'active' : ""}`}
                                onClick={() => dispatch({trigger: 'selectSubMenu', subMenu: 'activity'})}>
                                <div className="app-nav-item-group">
                                    <div className="app-nav-item-group__icon" icon-type="news"></div>
                                    <div className="app-nav-item-group__label">{t('@Activities@')}</div>
                                </div>

                            </li>
                        </Link>

                        <Link to="/account/contact" style={resetLink}>
                            <li className={`app-nav-item ${state.subMenu === 'contact' ? 'active' : ""}`}
                                onClick={() => dispatch({trigger: 'selectSubMenu', subMenu: 'contact'})}>
                                <div className="app-nav-item-group">
                                    <div className="app-nav-item-group__icon" icon-type="contacts"></div>
                                    <div className="app-nav-item-group__label">{t('@Contact List@')}</div>
                                </div>

                            </li>
                        </Link>

                        {app?.display_name &&
                            <>
                            <li class="app-nav-divider"></li>
                            <li className="app-nav-item" item-name="back-to-service">
                                <div className="app-nav-item-group" onClick={appRedirect}>
                                    <div className="app-nav-item-group__icon" icon-type="back-to"></div>
                                    <div className="app-nav-item-group__label" title={app?.display_name}>{t('@Back to@')} {`${app?.display_name}`}</div>
                                </div>
                            </li>
                            </>
                        }

                    </ul>

                    <ul>
                        <li className="app-nav-item" item-name="collapse">
                            <div className="app-nav-item-group" onClick={() => setCollapsed(prev => prev==='off' ? 'on' : 'off')}>
                                <div className="app-nav-item-group__icon" icon-type="collapse"></div>
                                <div className="app-nav-item-group__label">Collapse</div>
                            </div>
                        </li>
                    </ul>
                </>
            }
        </nav>

            <main className="app-main">
                <Outlet/>
            </main>
        </>
    );
}

export default Navigator;